// removed by extract-text-webpack-plugin
module.exports = {"component":"_21VTL2pe-oz-yCty42l3gh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Coupon/coupon.css
// module id = 1096
// module chunks = 2